import { Component, OnInit } from '@angular/core';
import { SecurityService } from '../security/security.service';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  styleUrls: ['./configuracion.component.scss']
})
export class ConfiguracionComponent implements OnInit {

  constructor(
    public securityService: SecurityService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/configuracion/configuracion.component.ts